import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import { ColumnFlexBox } from '../../../Components/FlexBox';
import CaptionValue from '../../../Components/CaptionValue/CaptionValue';
import { formatThousands } from '../../../Utils/constants/general';

const TooltipComponent = function TooltipComponent({ data }) {
  const intl = useIntl();

  const {
    entity,
    answeredNum,
    practices,
    accepted,
    retired,
    refused,
    waiting,
  } = data?.details || {};

  return (
    <ColumnFlexBox gap="8px" padding="8px" minWidth="240px">
      {entity && (
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            fontWeight: 'bold'
          }}>
          {entity}
        </Typography>
      )}
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontWeight: 'bold'
        }}>
        {intl.messages.ANSWERED_CALLS}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          color: data?.color,
          fontWeight: 'bold'
        }}>
        {formatThousands(answeredNum)}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontWeight: 'bold'
        }}>
        {intl.messages.PRACTICES}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          color: data?.color,
          fontWeight: 'bold'
        }}>
        {formatThousands(practices)}
      </Typography>
      <CaptionValue
        direction="row"
        width="100%"
        caption="ACCEPTED_PRACTICES"
        value={formatThousands(accepted)}
        valueColor={data?.color}
        captionStyle={{ flexGrow: 1 }}
        valueStyle={{ fontWeight: 'bold' }}
        captionColor="#fff"
      />
      <CaptionValue
        direction="row"
        width="100%"
        caption="RETIRED_PRACTICES"
        value={formatThousands(retired)}
        valueColor={data?.color}
        captionStyle={{ flexGrow: 1 }}
        valueStyle={{ fontWeight: 'bold' }}
        captionColor="#fff"
      />
      <CaptionValue
        direction="row"
        width="100%"
        caption="REFUSED_PRACTICES"
        value={formatThousands(refused)}
        valueColor={data?.color}
        captionStyle={{ flexGrow: 1 }}
        valueStyle={{ fontWeight: 'bold' }}
        captionColor="#fff"
      />
      <CaptionValue
        direction="row"
        width="100%"
        caption="WAITING_PRACTICES"
        value={formatThousands(waiting)}
        valueColor={data?.color}
        captionStyle={{ flexGrow: 1 }}
        valueStyle={{ fontWeight: 'bold' }}
        captionColor="#fff"
      />
    </ColumnFlexBox>
  );
};

export default TooltipComponent;
